import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import LazyLoading from '../../../components/LazyLoading';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { NonExchangeDay, defaultNonExchangeDay } from '../../../app/models/NonExchangeDay';
import NonExchangeDayForm from './forms/NonExchangeDayForm';
import useNonExchangeDayService from '../../../app/services/hooks/useNonExchangeDayService';
import { Currency } from '../../../app/models/Currency';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const NonExchangeDayCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [errorGetData, setErrorGetData] = useState('');
    const [nonExchangeDay, setNonExchangeDay] = useState<NonExchangeDay>(defaultNonExchangeDay);
    const [errorFields, setErrorFields] = useState<any>();
    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const { createNonExchangeDay, fetchingStoreNonExchangeDay, storeNonExchangeDay } = useNonExchangeDayService();

    useEffect(() => {
        create();
    }, []);

    const create = () => {
        if (showLoading) showLoading('loading', 'Cargando datos...');
        createNonExchangeDay({
            onSuccess: (response: ServiceResponse) => {
                setCurrencies(response.data.currencies);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando...');
        storeNonExchangeDay(nonExchangeDay, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.success('día de no cambio creado correctamente');
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
            },
            onFieldError: (response: ServiceResponse) => {
                console.log(response);
                setErrorFields(response.data);
                if (hideLoading) hideLoading();
                
            },
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <NonExchangeDayForm
                        nonExchangeDayDataForm={nonExchangeDay}
                        setNonExchangeDayDataForm={setNonExchangeDay}
                        errorFields={errorFields} currencies={currencies}                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStoreNonExchangeDay} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreNonExchangeDay} />
                </div>
            </div>
        </>
    );
};

export default NonExchangeDayCreate; 